import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';

import g from '#core/global';
import events from '#core/events';
import load from '#core/load';


const any_field_$ = 'input';
const show_invalid_c = 'show-invalid';
const date_field_$ = '.field.\\:type-datepicker input';
const datepicker_hide_delay = 250;
const gfield_hidden_label_$ = '.gfield.hidden_label';
const gfield_input_$ = '.gfield.hidden_label input';
const gfield_label_$ = '.gfield_label';
const has_value_c = 'has-value';

let has_datepicker = false;
let $datepickers = null;


const module = {
	date_field_$: date_field_$,
	
	// This is commented out to avoid circular dependencies
	// datepicker_$: '.air-datepicker',
	
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('field')) return false;
		
		load.content(() => {
			has_datepicker = assign_elements();
			if (!has_datepicker) return false;
		});
		load.all(() => {
			has_datepicker = assign_elements();
			if (!has_datepicker) return false;
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_datepicker) return true;
	
	// TODO: do not store objects on load, account for dynamic content
	// Highlight invalid fields on blur
	document.querySelectorAll(any_field_$).forEach($field => {
		$field.addEventListener(g.blur_e, () => {
			$field.classList.add(show_invalid_c);
		});
	});
	
	$datepickers = document.querySelectorAll(date_field_$);
	if ($datepickers) {
		$datepickers.forEach($datepicker => {
			init_datepicker($datepicker);
		});
	}

	// Hide Gravity Forms labels when field has value
	document.addEventListener(g.input_e, e => {
		const $input = e.target.closest(gfield_input_$);
		if (!$input) return;

		update_gfield_label($input);
	});

	document.addEventListener(g.blur_e, e => {
		const $input = e.target.closest(gfield_input_$);
		if (!$input) return;

		update_gfield_label($input);
	});

	// Initialize Gravity Forms labels
	document.querySelectorAll(gfield_input_$).forEach($input => {
		update_gfield_label($input);
	});

	return true;
}


/**
 * Update Gravity Forms label visibility based on input value
 * @param {element} $input
 * @return {boolean}
 */
function update_gfield_label($input) {
	const $gfield = $input.closest(gfield_hidden_label_$);
	if (!$gfield) return false;

	const $label = $gfield.querySelector(gfield_label_$);
	if (!$label) return false;

	if ($input.value && $input.value.length > 0) {
		$label.classList.add(has_value_c);
	} else {
		$label.classList.remove(has_value_c);
	}
}


/**
 * Initialize datepicker
 * @param {element} $datepicker
 */
function init_datepicker($datepicker) {
	new AirDatepicker($datepicker, {
		locale: localeEn,
		onShow: (isFinished) => {
		},
		onHide: (isFinished) => {
		},
		onSelect: ({datepicker}) => {
			setTimeout(() => {
				document.dispatchEvent(new CustomEvent(events.filter.request, {
					detail: {
						$source: $datepicker,
					},
				}));
				datepicker.hide();
			}, datepicker_hide_delay);
		},
	});
}
